<template>
  <div>
    <h1 class="mb-8 font-bold text-2xl">Liste des Ventes</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="sForm.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="mt-4 block text-gray-700">Trashed:</label>
        <select v-model="sForm.trashed" class="mt-1 w-full form-select">
          <option :value="null"/>
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
      </search-filter>
      <div class="flex">
        <button class="btn-indigo py-2.5 mr-4 flex items-center disabled:opacity-50" @click="submit('confirm')" :disabled="sending || selectedItems.length === 0">
          <div v-if="sending" class="btn-spinner mr-2" />
          <span>Confirmer le paiement</span>
        </button>
        <jet-danger-button :class="{ 'opacity-25': sending || selectedItems.length === 0 }" @click.native="submit('reject')" :disabled="sending || selectedItems.length === 0">
          Rejeter
        </jet-danger-button>
      </div>
    </div>
    <div class="bg-white rounded shadow overflow-x-auto">
      <table class="w-full whitespace-no-wrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4"><input type="checkbox" class="form-checkbox h-5 w-5" v-model="selectAll" @change="select"></th>
          <th class="px-2 pt-6 pb-4 items-center text-center">Client</th>
          <th class="px-2 pt-6 pb-4 items-center text-center">Type</th>
          <th class="px-2 pt-6 pb-4 items-center text-center">Reference</th>
          <th class="px-2 pt-6 pb-4 items-center text-center">Quantity</th>
          <th class="px-2 pt-6 pb-4 items-center text-center">Prix</th>
          <th class="px-2 pt-6 pb-4 items-center text-center">Marge</th>
          <th class="px-2 pt-6 pb-4 items-center text-center">Telephone</th>
          <th class="px-2 pt-6 pb-4 items-center text-center">Paiement</th>
          <th class="px-2 pt-6 pb-4 items-center text-center">Shop</th>
        </tr>
        <tr v-for="sale in sales.data" :key="sale.id" class="hover:bg-gray-100 focus-within:bg-gray-100 cursor-pointer" >
          <td class="border-t">
            <div class="px-6 py-4 flex items-center text-center focus:text-indigo-500">
              <input type="checkbox" class="form-checkbox h-5 w-5" :value="sale.id" v-model="selectedItems">
            </div>
          </td>
          <td class="border-t">
            <span class="px-4 py-4 flex items-center text-center">
              {{ sale.client }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-4 py-4 flex items-center text-center" tabindex="-1">
              {{ sale.type }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-4 py-4 flex items-center text-center" tabindex="-1">
              {{ sale.reference }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-4 py-4 flex items-center text-center" tabindex="-1">
              {{ sale.quantity }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-4 py-4 flex items-center text-center" tabindex="-1">
              {{ sale.price }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-4 py-4 flex items-center text-center" tabindex="-1">
              {{ sale.margin }}
            </span>
          </td>
          <td class="border-t" >
            <span class="px-4 py-4 flex items-center text-center" tabindex="-1">
              {{ sale.phone }}
            </span>
          </td>
          <td class="border-t" >
            <span class="px-4 py-4 flex items-center text-center" tabindex="-1">
              {{ sale.payment }}
            </span>
          </td>
          <td class="border-t" >
            <span class="px-4 py-4 flex items-center text-center" tabindex="-1">
              {{ sale.shopName }}
            </span>
          </td>
        </tr>
        <tr v-if="sales.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No sales found.</td>
        </tr>
      </table>
    </div>
    <pagination :links="sales.links"/>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Layouts/AppLayout'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import Pagination from '@/Shared/Pagination'
import throttle from "lodash/throttle";
import pickBy from "lodash/pickBy";
import JetDialogModal from '@/Jetstream/DialogModal'
import JetSecondaryButton from '@/Jetstream/SecondaryButton'
import TextInput from "@/Shared/TextInput"
import JetButton from '@/Jetstream/Button'
import TextareaInput from "@/Shared/TextareaInput"
import JetDangerButton from '@/Jetstream/DangerButton'
import JetInput from '@/Jetstream/Input'

export default {
  metaInfo: {title: 'Liste Ventes'},
  layout: Layout,
  components: {
    Icon,
    SearchFilter,
    Pagination,
    JetDialogModal,
    JetSecondaryButton,
    TextInput,
    JetButton,
    TextareaInput,
    JetDangerButton,
    JetInput,
  },
  props: {
    sales: Object,
    filters: Object,
    errors: Object,
  },
  data() {
    return {
      selectAll: false,
      sending: false,
      isLoading: false,
      processing: false,
      itemsData: [],
      selectedItems: [],
      sForm: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    sForm: {
      handler: throttle(function () {
        let query = pickBy(this.sForm)
        this.$inertia.replace(this.route('quote.sales', Object.keys(query).length ? query : {remember: 'forget'}))
      }, 150),
      deep: true,
    },
  },
  methods: {
    reset() {
      this.sForm = mapValues(this.sForm, () => null)
    },
    submit(action) {
      const data = new FormData()
      data.append('ids', this.selectedItems || [])
      data.append('action', action || null)
      this.$inertia.post(this.route('quote.payment'), data, {
        preserveScroll: true,
        onStart: () => this.sending = true,
        onFinish: () => {
          this.sending = false
          this.selectedItems = []
        }
      })
    },
    select() {
      this.selectedItems = [];
      if (this.selectAll) {
        for (let i in this.defects.data) {
          if (this.defects.data.hasOwnProperty(i)) {
            this.selectedItems.push(this.defects.data[i].id);
          }
        }
      }
    },
  },
}
</script>
